import { schema } from "normalizr";
import { DeliveryWindow } from "records/item";

export const DeliveryWindowSchema = new schema.Entity(
    "itemDeliveryWindows",
    {},
    {
        // _id is not unique so lets make it
        idAttribute: (value, parent) => {
            return `${parent._id}_${value._id}`;
        },
    }
);

(DeliveryWindowSchema as any).record = DeliveryWindow;
